const pauseButtons = document.querySelectorAll('section.header .pause-btn');

document.addEventListener('DOMContentLoaded', () => {
	// Handle video loading states
	const videoWrappers = document.querySelectorAll('section.header .video-wrapper');
	videoWrappers.forEach((wrapper) => {
		const iframe = wrapper.querySelector('iframe');
		const hasPlaceholder = wrapper.dataset.hasPlaceholder === 'true';
		const placeholder = hasPlaceholder ? document.querySelector('.video-placeholder') : null;
		const videoType = wrapper.dataset.video;

		if (iframe) {
			// If no placeholder, show video immediately
			if (!hasPlaceholder) {
				wrapper.classList.add('video-loaded');
				return;
			}

			// Show video when iframe loads (only if there's a placeholder)
			iframe.addEventListener('load', () => {
				// For YouTube, we need to wait for the player to be ready
				if (videoType === 'youtube') {
					// Add enablejsapi=1 to the src if not already present
					if (!iframe.src.includes('enablejsapi=1')) {
						const videoSrc = iframe.src;
						iframe.src = videoSrc + (videoSrc.includes('?') ? '&' : '?') + 'enablejsapi=1';
					}

					// Start checking immediately for player readiness
					checkYouTubeReady(iframe, wrapper, placeholder);
				} else if (videoType === 'vimeo') {
					// For Vimeo, start checking immediately
					checkVimeoReady(iframe, wrapper, placeholder);
				}
			});
		}
	});

	// Helper function to check if YouTube player is ready
	function checkYouTubeReady(iframe, wrapper, placeholder) {
		try {
			// Try to communicate with the player to see if it's ready
			iframe.contentWindow.postMessage(
				JSON.stringify({ event: 'command', func: 'getPlayerState', args: [] }),
				'*'
			);

			// Listen for response
			const messageHandler = (event) => {
				if (event.origin === 'https://www.youtube.com' && event.data.event === 'onReady') {
					window.removeEventListener('message', messageHandler);
					showVideo(wrapper, placeholder);
				}
			};

			window.addEventListener('message', messageHandler);

			// Start aggressive polling to detect when player is ready
			let pollCount = 0;
			const maxPolls = 50; // Poll up to 50 times (5 seconds max)

			const pollInterval = setInterval(() => {
				pollCount++;

				try {
					// Try to get player state - if it responds, player is ready
					iframe.contentWindow.postMessage(
						JSON.stringify({ event: 'command', func: 'getPlayerState', args: [] }),
						'*'
					);

					// If we can communicate with the player, it's ready
					if (pollCount > 5) {
						// Give it a few attempts to fully initialize
						clearInterval(pollInterval);
						window.removeEventListener('message', messageHandler);
						showVideo(wrapper, placeholder);
					}
				} catch (error) {
					// Player not ready yet, continue polling
				}

				// Stop polling after max attempts
				if (pollCount >= maxPolls) {
					clearInterval(pollInterval);
					window.removeEventListener('message', messageHandler);
					showVideo(wrapper, placeholder);
				}
			}, 100); // Poll every 100ms for immediate response
		} catch (error) {
			// If we can't communicate with the player, start polling immediately
			startFallbackPolling(iframe, wrapper, placeholder);
		}
	}

	// Helper function to check if Vimeo player is ready
	function checkVimeoReady(iframe, wrapper, placeholder) {
		try {
			// Try to communicate with the Vimeo player
			iframe.contentWindow.postMessage(JSON.stringify({ method: 'ping' }), '*');

			// Start aggressive polling for Vimeo
			let pollCount = 0;
			const maxPolls = 50;

			const pollInterval = setInterval(() => {
				pollCount++;

				try {
					// Try to ping the player
					iframe.contentWindow.postMessage(JSON.stringify({ method: 'ping' }), '*');

					// If we can communicate, player is ready
					if (pollCount > 3) {
						// Give it a few attempts
						clearInterval(pollInterval);
						showVideo(wrapper, placeholder);
					}
				} catch (error) {
					// Player not ready yet, continue polling
				}

				// Stop polling after max attempts
				if (pollCount >= maxPolls) {
					clearInterval(pollInterval);
					showVideo(wrapper, placeholder);
				}
			}, 100); // Poll every 100ms
		} catch (error) {
			// If we can't communicate, start fallback polling
			startFallbackPolling(iframe, wrapper, placeholder);
		}
	}

	// Fallback polling for when API communication fails
	function startFallbackPolling(iframe, wrapper, placeholder) {
		let pollCount = 0;
		const maxPolls = 30; // 3 seconds max

		const pollInterval = setInterval(() => {
			pollCount++;

			try {
				// Try to access iframe content - if successful, player might be ready
				if (iframe.contentWindow && iframe.contentWindow.document) {
					clearInterval(pollInterval);
					showVideo(wrapper, placeholder);
				}
			} catch (error) {
				// Cross-origin restriction, continue polling
			}

			// Stop polling after max attempts
			if (pollCount >= maxPolls) {
				clearInterval(pollInterval);
				showVideo(wrapper, placeholder);
			}
		}, 100); // Poll every 100ms
	}

	// Helper function to show video and hide placeholder
	function showVideo(wrapper, placeholder) {
		wrapper.classList.add('video-loaded');
		if (placeholder) {
			placeholder.classList.add('placeholder-hidden');
		}
	}

	pauseButtons.forEach((btn) => {
		let paused = false;
		btn.addEventListener('click', () => {
			const iframe = btn.parentNode.querySelector('iframe');
			const videoType = btn.parentNode.dataset.video;

			if ('youtube' === videoType) {
				if (iframe && !iframe.src.includes('enablejsapi=1')) {
					const videoSrc = iframe.src;
					iframe.src = videoSrc + (videoSrc.includes('?') ? '&' : '?') + 'enablejsapi=1';
				}

				const func = paused ? 'playVideo' : 'pauseVideo';
				if (iframe) {
					iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*');

					btn.querySelector('.fa-pause').classList.toggle('hidden!');
					btn.querySelector('.fa-play').classList.toggle('hidden!');
					paused = !paused;
				} else {
					console.log('No YouTube iframe found for this button');
				}
			}
			if ('vimeo' === videoType) {
				const func = paused ? 'play' : 'pause';
				if (iframe) {
					iframe.contentWindow.postMessage(JSON.stringify({ method: func }), '*');

					btn.querySelector('.fa-pause').classList.toggle('hidden!');
					btn.querySelector('.fa-play').classList.toggle('hidden!');
					paused = !paused;
				} else {
					console.log('No Vimeo iframe found for this button');
				}
			}
		});
	});
});
